<template>
    <div class="brand-support-settings__entry" :class="{ 'is-busy': busy, 'is-gone': !entry.available }">
        <span class="brand-support-settings__letter" aria-hidden="true">{{ entry.letter }}</span>
        <span class="brand-support-settings__entry-name">
            <template v-if="entry.available">{{ entry.name }}</template>
            <template v-else>
                Компания недоступна
                <small>У вас нет к ней доступа; запись остаётся в общем списке</small>
            </template>
        </span>
        <span class="brand-support-settings__actions">
            <span v-if="busy" class="brand-support-overview__spin"></span>
            <template v-if="entry.canReorder">
                <button
                    type="button"
                    class="button button_type_icon button_color_transp-black brand-support-settings__square"
                    :aria-label="`Поднять «${title}»`"
                    :disabled="disabled || index === 0"
                    @click="$emit('move-up', entry)"
                >
                    <svg aria-hidden="true" width="14" height="14"><use href="#icon-angle-up"></use></svg>
                </button>
                <button
                    type="button"
                    class="button button_type_icon button_color_transp-black brand-support-settings__square"
                    :aria-label="`Опустить «${title}»`"
                    :disabled="disabled || index === total - 1"
                    @click="$emit('move-down', entry)"
                >
                    <svg aria-hidden="true" width="14" height="14"><use href="#icon-angle-down"></use></svg>
                </button>
            </template>
            <v-button
                v-if="entry.canRemove"
                class="button_color_transp-black"
                size="small"
                :disabled="disabled"
                @click="$emit('remove', entry)"
            >
                Убрать из панели
            </v-button>
        </span>
    </div>
</template>

<script>
import vButton from '@components/global/vButton'

export default {
    name: 'CompanySettingsRow',
    components: {
        vButton,
    },
    props: {
        entry: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            default: 0,
        },
        total: {
            type: Number,
            default: 0,
        },
        busy: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        title() {
            return this.entry.name || 'Компания недоступна'
        },
    },
}
</script>
